import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@material-ui/core";
import { ApolloClient, ApolloProvider, InMemoryCache, ApolloLink, HttpLink, from, } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DayjsUtils from "@date-io/dayjs";
import frCH from "dayjs/locale/fr-ch";
import { toast } from "../Utils/toast";
import { theme } from "../Styles/theme";
import { ScrollToTop } from "../Router/ScrollToTop";
import "fontsource-roboto";
const localStorageNames = {
    JWT: "Jwt",
};
const MasterDefinition = createContext(undefined);
export const useMaster = () => useContext(MasterDefinition);
export const MasterProvider = ({ uri, children }) => {
    const [getDark, setDark] = React.useState(false);
    const [getErrors, setErrors] = React.useState([]);
    const [getJwt, setJwt] = React.useState(window.localStorage.getItem(localStorageNames.JWT) || undefined);
    const setJwtPersistant = (input) => {
        if (input) {
            window.localStorage.setItem(localStorageNames.JWT, input);
        }
        else {
            window.localStorage.removeItem(localStorageNames.JWT);
        }
        setJwt(input);
    };
    const logout = () => {
        setJwtPersistant();
        toast("Déconnection réussie");
    };
    const base = new HttpLink({
        uri,
    });
    const newError = (errorContent) => {
        console.log(errorContent);
        toast.error(errorContent);
        setErrors((error) => [...error, errorContent]);
    };
    const errorLink = onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
            graphQLErrors.forEach(({ message }) => {
                if (message.includes("JWT error") ||
                    message.includes("No user with that id")) {
                    logout();
                }
                const errorContent = `[Error]: ${message}`;
                newError(errorContent);
            });
        }
        if (networkError) {
            const isToBig = JSON.stringify(networkError).includes("PayloadTooLargeError");
            const errorContent = `[networkError]: ${isToBig ? "File to big" : JSON.stringify(networkError)}`;
            newError(errorContent);
        }
    });
    const authLink = new ApolloLink((operation, forward) => {
        operation.setContext(({ headers }) => ({
            headers: Object.assign({ authorization: getJwt }, headers),
        }));
        return forward(operation);
    });
    const link = from([errorLink, authLink, base]);
    const client = new ApolloClient({
        cache: new InMemoryCache(),
        link,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "no-cache",
                errorPolicy: "all",
            },
            query: {
                fetchPolicy: "no-cache",
                errorPolicy: "all",
            },
            mutate: {
                errorPolicy: "all",
            },
        },
    });
    const cleanErrors = () => setErrors([]);
    return (_jsx(MasterDefinition.Provider, Object.assign({ value: {
            setDark,
            getDark,
            getJwt,
            setJwtPersistant,
            logout,
            getErrors,
            newError,
            cleanErrors,
        } }, { children: _jsx(ThemeProvider, Object.assign({ theme: theme(getDark) }, { children: _jsxs(MuiPickersUtilsProvider, Object.assign({ utils: DayjsUtils, locale: frCH }, { children: [_jsx(CssBaseline, {}, void 0),
                    _jsxs(BrowserRouter, { children: [_jsx(ScrollToTop, {}, void 0),
                            _jsx(ApolloProvider, Object.assign({ client: client }, { children: children }), void 0)] }, void 0)] }), void 0) }), void 0) }), void 0));
};
//# sourceMappingURL=Master.js.map